module.exports = vendors_en_8e8bba20ca154d172ea6;